const Download = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.33301 10.3367V11.1667C1.33301 11.8297 1.5964 12.4656 2.06524 12.9344C2.53408 13.4033 3.16997 13.6667 3.83301 13.6667H12.1663C12.8294 13.6667 13.4653 13.4033 13.9341 12.9344C14.4029 12.4656 14.6663 11.8297 14.6663 11.1667V10.3333M7.99967 0.75V9.91667M7.99967 9.91667L10.9163 7M7.99967 9.91667L5.08301 7"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Download;
